import * as React from 'react'

import { Box, SearchField, SelectOption } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

import CodesFilter from './filters'

interface Props {
  options: SelectOption[]
  onSearch: (event: React.ChangeEvent<HTMLInputElement>) => void
  onChangeFilter: (type: string) => void
  filter: string
  search: string
}

const FiltersBox = ({ filter, onChangeFilter, search, options, onSearch }: Props) => {
  return (
    <Box gap="s8" flexNoShrink flexDirection="row">
      <Box>
        <CodesFilter filter={filter} options={options} onChangeFilter={onChangeFilter} />
      </Box>
      <Box width="full">
        <SearchField
          variant="big"
          onSearch={onSearch}
          search={search}
          placeholder={i18n.t('common.search')}
          autofocus
        />
      </Box>
    </Box>
  )
}

export default FiltersBox
